// 코드 블록 생성 헬퍼 함수 (서버/클라이언트 모두에서 사용 가능)
export const code = (lang: string, content: string): string => {
  // 공통 들여쓰기 제거 함수
  const removeCommonIndent = (text: string): string => {
    const lines = text.split("\n");

    // 앞뒤 빈 줄 제거
    while (lines.length > 0 && lines[0].trim() === "") {
      lines.shift();
    }
    while (lines.length > 0 && lines[lines.length - 1].trim() === "") {
      lines.pop();
    }

    if (lines.length === 0) return "";

    // 공통 들여쓰기 계산
    const nonEmptyLines = lines.filter((line) => line.trim() !== "");
    if (nonEmptyLines.length === 0) return lines.join("\n");

    const minIndent = Math.min(
      ...nonEmptyLines.map((line) => {
        const match = line.match(/^(\s*)/);
        return match ? match[1].length : 0;
      })
    );

    // 공통 들여쓰기 제거
    if (minIndent > 0) {
      return lines
        .map((line) => (line.trim() === "" ? line : line.substring(minIndent)))
        .join("\n");
    }

    return lines.join("\n");
  };

  const cleanedContent = removeCommonIndent(content);
  
  // 백틱 앞에 zero-width space를 추가하여 LaTeX 파서가 백틱을 수식으로 인식하지 않도록 함
  const zws = '\u200B'; // Zero Width Space
  return `${zws}\`\`\`${lang}\n${cleanedContent}\n\`\`\`\n`;
};

// wrappingBlock 헬퍼 함수 (className과 content를 받아서 특별한 마커로 감싸기)
export const wrappingBlock = (className: string, content: string): string => {
  // 내용 앞뒤 공백 정리
  const cleanedContent = content.trim();
  
  // 파싱 시 식별하기 쉽도록 특별한 마커 추가 (className 포함)
  return `__WRAPPING_START__${className}__WRAPPING_CONTENT__${cleanedContent}__WRAPPING_END__`;
};

// 테이블 생성 헬퍼 함수 (className과 마크다운 테이블을 받아서 특별한 마커로 감싸기)
export const table = (className: string, content: string): string => {
  const cleanedContent = content.trim();
  
  // 파싱 시 식별하기 쉽도록 특별한 마커 추가
  return `__TABLE_START__${className}__TABLE_CONTENT__${cleanedContent}__TABLE_END__`;
};
